import { useEffect, useState, useRef } from 'react'

import { UpdateNotificationCard } from '@/components/UpdateNotificationBanner/UpdateNotificationCard'

interface UpdateNotificationBannerProps {
  onReload?: () => void
}

export const UpdateNotificationBanner = ({
  onReload,
}: UpdateNotificationBannerProps) => {
  const [isVisible, setIsVisible] = useState(false)

  const isHandlingRef = useRef(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const handleUpdateAvailable = () => {
      if (isHandlingRef.current) {
        return
      }

      isHandlingRef.current = true
      setIsVisible(true)

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      timeoutRef.current = setTimeout(() => {
        isHandlingRef.current = false
        timeoutRef.current = null
      }, 1000)
    }

    window.addEventListener('app:update-available', handleUpdateAvailable)

    return () => {
      window.removeEventListener('app:update-available', handleUpdateAvailable)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [])

  const handleReload = () => {
    if (onReload) {
      onReload()
    } else {
      window.location.reload()
    }
  }

  const handleDismiss = () => {
    setIsVisible(false)

    try {
      sessionStorage.removeItem('myassetmap_update_notification_shown')
    } catch {
      // Ignore if sessionStorage is unavailable
    }
  }

  if (!isVisible) return null

  return (
    <UpdateNotificationCard onReload={handleReload} onDismiss={handleDismiss} />
  )
}
